import { editLesson } from "api/services/lesson-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useEditLesson = () => {
    const { callAPI, loading } = useWorkspaceApiCall(editLesson, 'editLesson.success', 'editLesson.error');

    return { editLesson: callAPI, editingLesson: loading };
}